import { defaultTextColor } from './defaults';
import { isValidColor } from './color';
var verifyOrFallback = verifyOrFallbackFactory();
export var verifyOrFallbackColor = function (fallback) {
    return verifyOrFallback(isValidColor, fallback);
};
export var verifyOrFallbackTextColor = verifyOrFallbackColor(defaultTextColor);
function verifyOrFallbackFactory() {
    return function (predicate, fallback) { return function (value) {
        if (predicate(value)) {
            return value;
        }
        return fallback;
    }; };
}
//# sourceMappingURL=verify-or-fallback.js.map